export const FAIL_AFTER_MS = 2 * 60_000

export function ms(iso: string | null | undefined): number | null {
	if (!iso) return null
	const t = Date.parse(iso)
	return Number.isFinite(t) ? t : null
}

export function clock(iso: string): string {
	const d = new Date(iso)
	return `${String(d.getHours()).padStart(2, "0")}:${String(d.getMinutes()).padStart(2, "0")}`
}

export function fullTime(iso: string | null | undefined): string {
	if (!iso) return "—"
	const d = new Date(iso)
	return d.toLocaleString(undefined, {
		month: "short",
		day: "numeric",
		hour: "2-digit",
		minute: "2-digit",
		second: "2-digit",
	})
}

/** 42s, 7m, 3h, 2d */
export function age(iso: string | null | undefined, now: number): string {
	const t = ms(iso)
	if (t === null) return "—"
	const s = Math.max(0, Math.round((now - t) / 1000))
	if (s < 60) return `${s}s`
	const m = Math.round(s / 60)
	if (m < 60) return `${m}m`
	const h = Math.round(m / 60)
	if (h < 48) return `${h}h`
	return `${Math.round(h / 24)}d`
}

/** 840ms, 3.2s, 1m4s */
export function dur(msv: number | string | null | undefined): string {
	if (msv === null || msv === undefined || msv === "") return "—"
	const v = Number(msv)
	if (!Number.isFinite(v)) return "—"
	if (v < 1000) return `${Math.round(v)}ms`
	if (v < 10_000) return `${(v / 1000).toFixed(1)}s`
	if (v < 60_000) return `${Math.round(v / 1000)}s`
	const m = Math.floor(v / 60_000)
	return `${m}m${Math.round((v % 60_000) / 1000)}s`
}

export function dayLabel(iso: string): string {
	const d = new Date(iso)
	const today = new Date()
	const y = new Date(today)
	y.setDate(today.getDate() - 1)
	if (d.toDateString() === today.toDateString()) return "Today"
	if (d.toDateString() === y.toDateString()) return "Yesterday"
	return d.toLocaleDateString(undefined, {
		weekday: "short",
		month: "short",
		day: "numeric",
	})
}
